module.exports = {"title":"泰山科技学院","baseApi":"http://58.56.217.180:8085/yingxin","payApi":"null","loginApi":"null","systemType":"yingxin","version":"1.0.0","code":200}


//////////////////
// WEBPACK FOOTER
// ./static/config/index.json
// module id = fhwO
// module chunks = 1